import type { NuxtUiTheme } from '../types/nuxt-ui-theme';

const statusBadgeBase = 'rounded-[6.188rem] border text-xs font-bold uppercase tracking-wide';

export default {
    variants: {
        variant: {
            new: `${statusBadgeBase} border-(--status-new-border) bg-(--status-new-bg) text-(--status-new-text)`,
            estimated:
                statusBadgeBase +
                ' border-(--status-estimated-border) bg-(--status-estimated-bg) text-(--status-estimated-text)',
            inProgress:
                statusBadgeBase +
                ' border-(--status-in-progress-border) bg-(--status-in-progress-bg) text-(--status-in-progress-text)',
            notEstimated:
                statusBadgeBase +
                ' border-(--status-not-estimated-border) bg-(--status-not-estimated-bg) ' +
                'text-(--status-not-estimated-text)',
            unknown: `${statusBadgeBase} border-(--neutral-border-light) bg-(--status-unknown-bg) text-(--text-medium)`,
            location:
                'rounded-[6.188rem] border border-(--white-alpha-15) bg-(--black-alpha-35) px-3 py-[0.35rem] ' +
                'uppercase text-(--pure-white) shadow-[0_0.125rem_0.5rem_rgba(0,0,0,0.2)] backdrop-blur-[1rem]'
        }
    }
} satisfies NuxtUiTheme['badge'];
